import { useQuery } from 'react-query';
import ApplicationService from '../../../../services/applicationService';

export type UseApplicationParams = {
  applicationId: string,
  organizationId: string,
  propertyId: string,
};

export type UseApplicationReturn = {
  application: any | undefined,
  isLoading: boolean,
};

export default function useApplication({
  applicationId,
  organizationId,
  propertyId,
}: UseApplicationParams): UseApplicationReturn {
  const queryKey = ['application', organizationId, propertyId, applicationId];

  const applicationService = new ApplicationService();

  const { data, isLoading } = useQuery(
    queryKey,
    () => {
      return applicationService.getApplication(
        organizationId,
        propertyId,
        applicationId,
      );
    },
    { refetchOnWindowFocus: false },
  );

  return { application: data, isLoading };
}
